<template>
    <div ref="countryContainer">
        <select
            v-validate="required ? 'truthy' : false"
            :ref="label"
            :name="label"
            @change="changeHandler"
            :id="label"
        >
            <option
                v-if="defaultOption"
                :value="false"
                disabled
                :selected="hasValue ? false : true"
                :key="defaultOption"
            >
                {{ defaultOption }}
            </option>
            <option
                v-for="(option, ind) in options"
                :class="`${option.classes}`"
                :key='ind'
                :value="option.value"
                :data-code="option.code"
                :data-selected="isSelected(option.value)"
            >
                <span>
                    <slot :slotKey="option.code"></slot>{{ option.value }}
                </span>
            </option>
        </select>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import createCustomSelect from '@H/custom-select';
import { addSearch } from '@H/search';
import popperManager from '@M/popperManager';

export default {
    mixins: [popperManager],
    inject: ['$validator'],
    name: 'CountrySelect',
    mounted() {
        this.popperId = createCustomSelect(this.$refs[this.label], { withDivider: true });
        this.toggleSelectDisability(this.disabledCheck);
        addSearch(this.$gettext, document.body, {
            target: `[data-panel-id="${this.popperId}"] .custom-select-panel`,
            searchWrapperClass: 'country-search',
            searchLabelClass: 'country-search__label',
            searchInputClass: 'country-search__input',
            searchables: this.options,
            byDataCode: true
        });
        // True as first time run
        this.handler(this.$refs[this.label], true);
    },
    methods: {
        isSelected(opt) {
            return this.hasValue && this.hasValue == opt;
        },
        changeHandler: function (e) {
            if (this.handler) {
                this.$validator
                    ? this.$validator.validate(e.target.name, e.target.value)
                    : null;
                this.handler(e);
            }
        },
        mimicOptionClick(val) {
            const innerSelect = this.$refs[this.label];
            const customSelect = innerSelect.parentNode;
            const panel = document.body.querySelector(`[data-panel-id="${this.popperId}"]`)
            const opt = panel.querySelector(
                `.custom-select-option[data-value="${val}"]`
            );
            const opener = customSelect.querySelector('.custom-select-opener');

            innerSelect.value = val;
            customSelect.classList.remove('is-open');
            opener.innerHTML = opt.innerHTML;
            opener.setAttribute('data-value', val);

            this.setCountry(val);
            this.getIsoCodeFromName(val, this.options);
        },
        toggleSelectDisability(val) {
            let innerSelect = this.$refs[this.label];
            let customSelect = innerSelect.parentNode;
            if (val) {
                customSelect.classList.add('is-disabled');
            } else {
                customSelect.classList.remove('is-disabled');
            }
        }
    },
    watch: {
        hasValue(val) {
            if (val) {
                this.mimicOptionClick(val);
            }
        },
        isDisabled(val) {
            this.toggleSelectDisability(val);
        }
    },
    computed: {
        ...mapState(['formSubmitting']),
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        }
    },
    props: {
        options: {
            type: [Array, Object],
            required: true
        },
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        handler: {
            type: Function
        },
        defaultOption: {
            type: [String, Number, Boolean],
            default: false
        },
        hasValue: {
            type: [String, Boolean],
            default: false
        },
        setCountry: {
            type: Function,
            required: true
        },
        getIsoCodeFromName: {
            type: Function,
            required: true
        },
        disabledCheck: {
            type: Boolean,
            default: false
        }
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/CountrySelect.vue